import {css, html} from "@isceco/widget-library2/external/lit"
import '../../../../components/RadioGroupVertical/CustomRadioGroupVertical'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/DropdownMultiselect/DropdownMultiselect'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import SbfiGesuchService from "./SbfiGesuchService"
import FormComponent from "../../../../components/FormComponent";
import I18n from './../../../../i18n'

export default class Gesuch extends FormComponent {

  kantonCodes = [
    'ZH',
    'BE',
    'LU',
    'UR',
    'SZ',
    'OW',
    'NW',
    'GL',
    'ZG',
    'FR',
    'SO',
    'BS',
    'BL',
    'SH',
    'AR',
    'AI',
    'SG',
    'GR',
    'AG',
    'TG',
    'TI',
    'VD',
    'VS',
    'NE',
    'GE',
    'JU'
  ];

  static WEBSITE_PATTERN = '^(https?:\\/\\/)?(www\\.)?([a-zA-Z0-9\\-]+\\.)+[a-zA-Z]{2,}(\\/.*)?$';
  static PHONE_PATTERN_INTL_CH = '^(?:\\+\\d\\d|00\\d\\d|0)(?:\\s?\\d){9,15}$';

  constructor() {
    super()
    this.selectedLocation = null;
    this.selectedPermission = null;
    this._finanzenSubtotal = 0;
    this._finanzenTotal = 0;
    this._finanzenPauschale = 0;

    this.kantonItems = [];
    this._onLanguageChanged = () => {
      this._updateKantonItems();
    };
  }
  get translationFile() {
    return './views/WBF/SBFI/Gesuch/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.initialized.then(() => {
      this._initKantone()
      this.reload()
    })
    document.addEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._onLanguageChanged);
  }
  disconnectedCallback() {
    document.removeEventListener(I18n.EVENT_KEYS.CHANGE_LANGUAGE, this._onLanguageChanged);
    super.disconnectedCallback();
  }

  get css() {
    return css`
      .form-elements isceco-card {
        margin-bottom: var(--isceco-space-300);
      }

      .form-card {
        display: flex;
        flex-flow: column nowrap;
        gap: var(--isceco-space-200);
      }
      .checkbox-grid{
        display: grid;
      }
      .checkbox-grid isceco-checkbox {
        margin-top: -5px;
        margin-bottom: -5px;
      }
      .cols {
        display: flex;
        flex-direction: column;
        gap: 1rem;
      }
      .cols > * {
        flex: 1;
        min-width: 0;
      }
      @media (min-width: 768px) {
        .cols {
          flex-direction: row;
        }
      }
      .popup-wrapper{
        display: flex;
        align-items: center;
        gap: 0.1rem;
        margin-bottom: -2rem;
      }
      .characteristics ul {
        list-style: disc;
      }
      .characteristics ul li {
        padding: 0.5rem 0;
      }
      .short-header {
        margin-bottom: 0px;
      }
      isceco-card .header {
        margin-bottom: 0;
      }
    `
  }
  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="sbfi-gesuch-form"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}"
      >
        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>
        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>
    `
  }

  getFormElements = () => {
    return html`
      ${this._renderGesuchsteller()}
      ${this._renderKontaktperson()}
      ${this._renderMassnahme()}
      ${this._renderGrundkompetenzen()}
      ${this._renderOrtDauer()}
      ${this._renderFinanzen()}
      ${this._renderInformation()}
      ${this._renderActiondetails()}
      ${this._renderBildungsanbietende()}
      ${this._renderZustellung()}
    `
  }

  _renderGesuchsteller = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.request.gesuchsteller')}" class="form-card">
        <isceco-text-input label="${this.i18n.translate('form.request.gesuchsteller.firma')}"
                           name="gesuchsteller.firma"
                           required
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-text-input label="${this.i18n.translate('form.request.gesuchsteller.zusatz')}"
                           name="gesuchsteller.zusatz"
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.strasse')}"
                             name="gesuchsteller.strasse"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.request.hausnummer')}"
                             name="gesuchsteller.hausnummer"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <div class="cols">
          <isceco-number-input label="${this.i18n.translate('form.request.plz')}"
                               name="gesuchsteller.plz"
                               required
                               min="1000"
                               max="9999"
                               maximum-fraction-digits="0"
                               .readonly="${this.preview}"
                               style="flex-grow: 0.5"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.request.ort')}"
                             name="gesuchsteller.ort"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <isceco-text-input label="${this.i18n.translate('form.request.gesuchsteller.webseite')}"
                           name="gesuchsteller.webseite"
                           required
                           pattern="${Gesuch.WEBSITE_PATTERN}"
                           pattern-error-text="${this.i18n.translate('form.request.website.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>`

  }
  _renderKontaktperson = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.title.request.kontaktperson')}" class="form-card">
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.vorname')}"
                             name="kontaktperson.vorname"
                             .value="${this._getAttributeFromTokenParsed('given_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.nachname')}"
                             name="kontaktperson.nachname"
                             .value="${this._getAttributeFromTokenParsed('family_name')}"
                             required
                             .readonly="${this.preview}"
          ></isceco-text-input>
        </div>
        <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.tel')}"
                           name="kontaktperson.telefon"
                           required
                           pattern="${Gesuch.PHONE_PATTERN_INTL_CH}"
                           pattern-error-text="${this.i18n.translate('form.request.phone.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-text-input label="${this.i18n.translate('form.request.kontaktperson.email')}"
                           name="kontaktperson.email"
                           .value="${this._getAttributeFromTokenParsed('email')}"
                           required
                           type="email"
                           pattern-error-text="${this.i18n.translate('form.request.email.error')}"
                           .readonly="${this.preview}"
        ></isceco-text-input>
      </isceco-card>
    `
  }
  _renderMassnahme = () => {
    return html`
      <isceco-title text="${this.i18n.translate('form.request.massnahme')}"></isceco-title>
      <isceco-card text="${this.i18n.translate('form.request.massnahme.titel')}" class="form-card">
        <isceco-text-input label="${this.i18n.translate('form.request.massnahme.titel.titel')}"
                           name="massnahme.titel"
                           required
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <isceco-textarea label="${this.i18n.translate('form.request.massnahme.titel.beschreibung')}"
                         name="massnahme.beschreibung"
                         rows="4"
                         required
                         .readonly="${this.preview}"
        ></isceco-textarea>
        <isceco-textarea label="${this.i18n.translate('form.request.massnahme.titel.zielpublikum')}"
                         name="massnahme.zielpublikum"
                         rows="3"
                         required
                         .readonly="${this.preview}"
        ></isceco-textarea>
      </isceco-card>
    `
  }
  _renderGrundkompetenzen = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.grundkompetenzen.title')}" class="form-card">
        <h4>${this.i18n.translate('form.request.grundkompetenzen.question')}</h4>
        <div class="checkbox-grid">
          <isceco-checkbox
            name="grundkompetenzen.lesen"
            label="${this.i18n.translate('form.request.grundkompetenzen.lesen')}"
            .readonly="${this.preview}"
          ></isceco-checkbox>
          <isceco-checkbox
            name="grundkompetenzen.schreiben"
            label="${this.i18n.translate('form.request.grundkompetenzen.schreiben')}"
            .readonly="${this.preview}"
          ></isceco-checkbox>
          <isceco-checkbox
            name="grundkompetenzen.lokaleSprache"
            label="${this.i18n.translate('form.request.grundkompetenzen.lokalesprache')}"
            .readonly="${this.preview}"
          ></isceco-checkbox>
          <isceco-checkbox
            name="grundkompetenzen.mathematik"
            label="${this.i18n.translate('form.request.grundkompetenzen.mathematik')}"
            .readonly="${this.preview}"
          ></isceco-checkbox>
          <isceco-checkbox
            name="grundkompetenzen.ikt"
            label="${this.i18n.translate('form.request.grundkompetenzen.ikt')}"
            .readonly="${this.preview}"
          ></isceco-checkbox>
        </div>
      </isceco-card>
    `
  }
  _renderOrtDauer = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.ortDauer.title')}" class="form-card">
        <div class="cols">
          <isceco-date-input label="${this.i18n.translate('form.request.ortDauer.start')}"
                             name="ortDauer.startdatumGeplant"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-date-input>
          <isceco-date-input label="${this.i18n.translate('form.request.ortDauer.end')}"
                             name="ortDauer.enddatumGeplant"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-date-input>
        </div>
        <isceco-number-input label="${this.i18n.translate('form.request.ortDauer.groupcount')}"
                             name="ortDauer.anzahlgruppen"
                             required
                             .readonly="${this.preview}"
        ></isceco-number-input>
        <isceco-dropdown-multiselect
          title="canton"
          name="ortDauer.kantone"
          placeholder="${this.i18n.translate('form.request.ortDauer.placeholder')}"
          label="${this.i18n.translate('form.request.ortDauer.kantone')}"
          .items="${this.kantonItems}"
          .readonly="${this.preview}"
        ></isceco-dropdown-multiselect>
        <h4 class="short-header">${this.i18n.translate('form.request.ortDauer.where')}</h4>
        <isceco-custom-radio-group-vertical
          name="ortDauer.location"
          .items="${[{
            value: 'am Arbeitsplatz',
            name: this.i18n.translate('form.request.ortDauer.workplace')
          },
            {
              value: 'an einem anderen Ort',
              name: this.i18n.translate('form.request.ortDauer.notworkplace')
            }]}"
          required
          @change="${this._onLocationChanged}"
          .readonly="${this.preview}"
        ></isceco-custom-radio-group-vertical>
        ${this.selectedLocation === 'an einem anderen Ort'
          ? html`
            <isceco-textarea
              label="${this.i18n.translate('form.request.ortDauer.address')}"
              name="ortDauer.address"
              rows="3"
              required
              .readonly="${this.preview}"
            ></isceco-textarea>
          `
          : ''}
      </isceco-card>
    `
  }
  _renderFinanzen = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.finanzen.title')}" class="form-card">
        <p>${this.i18n.translate('form.request.finanzen.description')}</p>
        <div class="cols">
          <isceco-number-input label="${this.i18n.translate('form.request.finanzen.teilnehmende')}"
                               name="finanzen.teilnehmende"
                               required
                               .readonly="${this.preview}"
                               @change="${this._onfinanzenChange}"
                               min="3"
                               maximum-fraction-digits="0"
          ></isceco-number-input>
          <isceco-number-input label="${this.i18n.translate('form.request.finanzen.lektionen')}"
                               name="finanzen.lektionen"
                               required
                               .readonly="${this.preview}"
                               @change="${this._onfinanzenChange}"
                               min="20"
                               max="40"
                               maximum-fraction-digits="0"
          ></isceco-number-input>
          <isceco-text-input
            label="${this.i18n.translate('form.request.finanzen.subtotal')}"
            readonly="true"
            name="finanzen.subtotal"
          ></isceco-text-input>
        </div>
        <div class="popup-wrapper">
          <p>${this.i18n.translate('form.request.finanzen.notice')}</p>
          <isceco-popup direction="right">
            <i slot="wrapper" class="icon info circle"></i>
            <div slot="content">
              <span style="font-size: 0.9rem">${this.i18n.translate('form.request.finanzen.notice.description')}</span>
            </div>
          </isceco-popup>
        </div>
        <isceco-checkbox
          name="finanzen.pauschaleAktiv"
          label="${this.i18n.translate('form.request.yes')}"
          @change="${this._onPauschaleCheckboxChange}"
          .readonly="${this.preview}"
        ></isceco-checkbox>
        <div class="cols">
          <div></div>
          <isceco-text-input
            label="${this.i18n.translate('form.request.finanzen.pauschale')}"
            name="finanzen.pauschaleBetrag"
            readonly="true"
          ></isceco-text-input>
          <isceco-text-input
            label="${this.i18n.translate('form.request.finanzen.total')}"
            name="finanzen.total"
            readonly="true"
          ></isceco-text-input>
        </div>
      </isceco-card>
    `
  }
  _renderInformation = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.information.auskunft.title')}" class="form-card">
        <isceco-radio-group
          value="Ja"
          label="${this.i18n.translate('form.request.information.permission')}"
          name="information.informationsweitergabe"
          .disabled="${this.preview}"
          .items="${[
            {
              value: 'Ja',
              name: this.i18n.translate('form.request.yes')
            },
            {
              value: 'Nein',
              name: this.i18n.translate('form.request.no')
            }
          ]}"
          inline
          @change="${this._onPermissionChanged}"
        ></isceco-radio-group>
        ${this.selectedPermission === 'Nein' ? html`
          <isceco-textarea
            label="${this.i18n.translate('form.request.information.permission.not')}"
            name="information.textFallsNein"
            rows="3"
            .readonly="${this.preview}"
          ></isceco-textarea>
        ` : ''}
      </isceco-card>
      <isceco-card text="${this.i18n.translate('form.request.information.title')}" class="form-card">
        <isceco-textarea label="${this.i18n.translate('form.request.information.notice')}"
                         name="information.textEinfachBesser"
                         help-text="${this.i18n.translate('form.request.information.notice.description')}"
                         rows="3"
                         .readonly="${this.preview}"
        ></isceco-textarea>
      </isceco-card>
    `
  }
  _renderActiondetails = () => {
    return html`
      <isceco-title text="${this.i18n.translate('form.request.actiondetails.title')}"></isceco-title>
      <isceco-card class="form-card">
        <h4 style="margin: 0">${this.i18n.translate('form.request.actiondetails.description')}</h4>
      </isceco-card>
      <isceco-card text="${this.i18n.translate('form.request.actiondetails.characteristics.title')}" class="form-card">
        <div class="characteristics">
          <ul>
            <li>
              <div class="popup-wrapper" style="margin-bottom: 0">
                ${this.i18n.translate('form.request.actiondetails.characteristics.line1')}
                <isceco-popup direction="right">
                  <i slot="wrapper" class="icon info circle"></i>
                  <div slot="content">
                    <span style="font-size: 0.9rem">${this.i18n.translate('form.request.actiondetails.characteristics.line1.notice.description')}</span>
                  </div>
                </isceco-popup>
              </div>
            </li>
            <li>${this.i18n.translate('form.request.actiondetails.characteristics.line2')}</li>
            <li>${this.i18n.translate('form.request.actiondetails.characteristics.line3')}</li>
            <li>${this.i18n.translate('form.request.actiondetails.characteristics.line4')}</li>
          </ul>
        </div>
        <h4 style="color:#ff0000">${this.i18n.translate('form.request.actiondetails.characteristics.warning')}</h4>
        <isceco-file-input label="${this.i18n.translate('form.request.actiondetails.characteristics.upload')}"
                           name="attachments"
                           required
                           multiple
                           maxfiles="5"
                           maxsize="${this.fileMaxSize}"
                           .fileInputService="${this.fileInputService}"
                           .disabled="${this.preview}"
        ></isceco-file-input>
      </isceco-card>
    `
  }
  _renderBildungsanbietende = () => {
    return html`
      <isceco-card text="${this.i18n.translate('form.request.bildungsanbietende.title')}" class="form-card">
        <h4 style="margin: 0">${this.i18n.translate('form.request.bildungsanbietende.question')}</h4>
        <isceco-custom-radio-group-vertical
          name="bildungsanbietende.bildungIntExt"
          required
          .items="${[{
            value: 'intern',
            name: this.i18n.translate('form.request.bildungsanbietende.intern')
          },
            {
              value: 'extern',
              name: this.i18n.translate('form.request.bildungsanbietende.extern')
            }]}"
          .readonly="${this.preview}"
        ></isceco-custom-radio-group-vertical>
        <isceco-text-input label="${this.i18n.translate('form.request.bildungsanbietende.name')}"
                           name="bildungsanbietende.name"
                           required
                           .readonly="${this.preview}"
        ></isceco-text-input>
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.strasse')}"
                             name="bildungsanbietende.strasse"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
          <isceco-text-input label="${this.i18n.translate('form.request.hausnummer')}"
                             name="bildungsanbietende.hausnummer"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <div class="cols">
          <isceco-number-input label="${this.i18n.translate('form.request.plz')}"
                             name="bildungsanbietende.plz"
                             required
                             min="1000"
                             max="9999"
                             maximum-fraction-digits="0"
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-number-input>
          <isceco-text-input label="${this.i18n.translate('form.request.ort')}"
                             name="bildungsanbietende.ort"
                             required
                             .readonly="${this.preview}"
                             style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
        <isceco-textarea label="${this.i18n.translate('form.request.bildungsanbietende.qualifikationen')}"
                         name="bildungsanbietende.qualifikationen"
                         required
                         maxlength="100"
                         rows="4"
                         .readonly="${this.preview}"
        ></isceco-textarea>
      </isceco-card>
    `
  }
  _renderZustellung = () => {
    return html`
      <isceco-title text="${this.i18n.translate('form.request.zustellung.request.title')}"></isceco-title>
      <isceco-card class="form-card">
        <h4 style="margin: 0">${this.i18n.translate('form.request.zustellung.email.title')}</h4>
        <p>${this.i18n.translate('form.request.zustellung.email.information')}</p>
        <div class="cols">
          <isceco-text-input label="${this.i18n.translate('form.request.zustellung.email')}"
                             name="zustellung.email"
                             .value="${this._getAttributeFromTokenParsed('email')}"
                             type="email"
                             pattern-error-text="${this.i18n.translate('form.request.email.error')}"
                             .readonly="${this.preview}"
          ></isceco-text-input>
          <div class="empty-div"></div>
        </div>
      </isceco-card>
    `
  }
  _submit = event => {
    if (!this.preview) {
      this.preview = true;
      this.render();
      return;
    }

    const formValues = event.detail;

    if (!formValues.finanzen) {
      formValues.finanzen = {};
    }

    formValues.finanzen.pauschaleBetrag = this._finanzenPauschale;
    formValues.finanzen.subtotal = this._finanzenSubtotal;
    formValues.finanzen.total = this._finanzenTotal;

    new SbfiGesuchService().submit(formValues, event.target);
  };

  _onfinanzenChange = () => {
    const teilnehmende = parseInt(
      this.querySelector('[name="finanzen.teilnehmende"]')?.value || 0,
      10
    );

    const lektionen = parseInt(
      this.querySelector('[name="finanzen.lektionen"]')?.value || 0,
      10
    );

    const subtotal = teilnehmende * lektionen * 15;
    const total = subtotal + this._finanzenPauschale;

    this._finanzenSubtotal = subtotal;
    this._finanzenTotal = total;

    this.querySelector('[name="finanzen.subtotal"]').value =
      this._formatCH(subtotal);

    this.querySelector('[name="finanzen.total"]').value =
      this._formatCH(total);
  };


  _onPauschaleCheckboxChange = e => {
    const isChecked = !!e.detail?.value;

    this._finanzenPauschale = isChecked ? 3000 : 0;

    const flatrateInput = this.querySelector(
      'isceco-text-input[name="finanzen.pauschaleBetrag"]'
    );

    if (flatrateInput) {
      flatrateInput.value = this._formatCH(this._finanzenPauschale);
    }

    this._onfinanzenChange();
  };
  _formatCH(val) {
    if (!val || isNaN(val)) {
      return "CHF 0";
    }
    return "CHF " + val.toLocaleString("de-CH");
  }
  _onLocationChanged = e => {
    this.selectedLocation = e.detail.value;
    this.render();
  };
  _onPermissionChanged = e => {
    this.selectedPermission = e.detail.value;
    this.render();
  };

  _initKantone() {
    const locale = this.i18n?.locale || this.i18n?.language || 'de-CH';

    const collator = new Intl.Collator(locale, {
      sensitivity: 'base',
      numeric: true
    });

    this.kantonItems = this.kantonCodes
      .map(code => ({
        value: code,
        name: this.i18n.translate(`canton.${code}`)
      }))
      .sort((a, b) => collator.compare(a.name, b.name));
  }
  _updateKantonItems() {
    const collator = new Intl.Collator(getLanguage(), {
      sensitivity: 'base',
      numeric: true
    });

    this.kantonItems = this.kantonCodes
      .map(code => ({
        value: code,
        name: this.i18n.translate(`canton.${code}`)
      }))
      .sort((a, b) => collator.compare(a.name, b.name));

    this.requestUpdate();
  }


}
customElements.define('eform-sbfi-gesuch', Gesuch)
